package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.widget.HorizontalLabelValue
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.answered_question
import inspection.composeapp.generated.resources.conducted
import inspection.composeapp.generated.resources.location
import inspection.composeapp.generated.resources.vessel
import org.jetbrains.compose.resources.stringResource

@Composable
fun InspectionInfo(
    locationName: String,
    lastUpdated: String,
    conducted: String,
    vesselName: String,
    modifier: Modifier = Modifier,
    totalDisplayAnswer: String = ""
) {
    Column(
        modifier = modifier
    ) {
        if (totalDisplayAnswer.isNotEmpty()) {
            HorizontalLabelValue(
                label = stringResource(Res.string.answered_question),
                value = totalDisplayAnswer,
            )
        }

        HorizontalLabelValue(
            label = stringResource(Res.string.vessel),
            value = vesselName
        )

        HorizontalLabelValue(
            label = stringResource(Res.string.location),
            value = locationName
        )

        if (conducted.isNotBlank()) {
            HorizontalLabelValue(
                label = stringResource(Res.string.conducted),
                value = DateTimeUtil.getLocalSystemDisplayWithTime(
                    conducted
                )
            )
        }

        HorizontalLabelValue(
            label = "Last Update",
            value = DateTimeUtil.getLocalSystemDisplayWithTime(
                lastUpdated
            )
        )

        Spacer(modifier = Modifier.height(LocalAppTheme.current.dimension.spacing.space4))
    }
}
